import {
  ADMIN_CURRENCY_LIST_SUCCESS,
  ADMIN_CURRENCY_LIST_FAILED,
  RESET_ADMIN_CURRENCY_LIST,
  LOADING_ADMIN_CURRENCY_LIST,
  NETWORK_ERROR_ADMIN_CURRENCY_LIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADMIN_CURRENCY_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case ADMIN_CURRENCY_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case ADMIN_CURRENCY_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_ADMIN_CURRENCY_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_ADMIN_CURRENCY_LIST:
      return (state = initialState);
    default:
      return state;
  }
};
